import React from 'react'

import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";

const Contactsupport = () => {
  return (
    <div className="bg-white text-center p-10 rounded-lg shadow-lg max-w-4xl mx-auto my-10">
    <h1 className="text-3xl font-bold mb-4">
      We are here for you, <br />
      contact us at <span className="text-blue-600">anytime</span>
    </h1>
    <p className="text-gray-600 mb-8">
      Have any questions about our services or just want to talk with us? Please reach out.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center">
      <a
        href="https://wa.me/+2349138920379" // Replace with your WhatsApp number
        className=" bg-green-500 p-1 rounded-full text-white shadow-lg hover:bg-green-600 transition duration-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={20} />
      </a>
        <h2 className="text-xl font-semibold mb-2">Chat Now</h2>
        <a
          href="https://wa.me/+2349138920379" // Replace with your WhatsApp number
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          target="_blank"
          rel="noopener noreferrer"
        >
          Start chat &rarr;
        </a>
      </div>

      <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center">
        <MdOutlineEmail />
        <h2 className="text-xl font-semibold mb-2">Email Us</h2>
        <p className="text-gray-600 mb-4">From your email app</p>
        <a href="customercare@sanieldanproperties.com" className="text-blue-600 text-xs">customercare@sanieldanproperties.com</a>
      </div>

      <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center">
      <IoCall />
        <h2 className="text-xl font-semibold mb-2">Call or text us</h2>
      
        <a
          href="https://wa.me/+2349138920379" // Replace with your WhatsApp number
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          target="_blank"
          rel="noopener noreferrer"
        >
          +2349138920379
        </a>
      </div>

      <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center">
        <FaInstagram />
        <h2 className="text-xl font-semibold mb-2">Instagram</h2>
        
        <a href="https://www.instagram.com/sanieldanproperties?igsh=dzBpNHI3YzVxZ25r" className="text-blue-600">@sanieldanproperties</a>
      </div>

  
      <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center">
      <FaFacebookF />
        <h2 className="text-xl font-semibold mb-2">Facebook</h2>
        
        <a href="https://www.facebook.com/officialsandrawills?mibextid=kFxxJD" className="text-blue-600">@officialsandrawills</a>
      </div>

      {/* <div className="bg-gray-100 p-6 rounded-lg shadow-md flex flex-col items-center">
      <FaXTwitter />
        <h2 className="text-xl font-semibold mb-2">Twitter</h2>
       
        <a href="https://www.facebook.com/officialsandrawills?mibextid=kFxxJD" className="text-blue-600">@officialsandrawills</a>
      </div> */}

   
    </div>
    <p className="text-gray-600 mt-8">
      We'll get back to you as soon as possible. Our team is available 8am-6pm on weekdays.
    </p>
  </div>
  )
}

export default Contactsupport